import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import * as identityProviderAPI from '~api/identity-providers';

import IString from '~components/general/i-string';
import IdentityProviderDetails from '~components/identity-providers/identity-provider-details';

export default function IdentityProviderPage() {
  const { identityProviderId } = useParams();
  const { state } = useLocation();
  const [ identityProvider, setIdentityProvider ] = useState(state?.identityProvider);

  useEffect(() => {
    if (identityProviderId !== identityProvider?.id) {
      (async () => {
        const { data } = await identityProviderAPI.getIdentityProvider(identityProviderId);
        setIdentityProvider(data);
      })();
    }
  }, [ identityProvider?.id, identityProviderId ]);

  if (identityProvider) {
    return (
      <>
        <h1><IString stringKey="identityProvider.details.title" placeholders={{ name: identityProvider.name }} /></h1>
        <IdentityProviderDetails identityProvider={identityProvider} onUpdate={setIdentityProvider} />
      </>
    );
  }
  return <span><IString stringKey={'general.loading'} /></span>;
}
